import {
  CompensationMethod,
  DraftReturn,
} from "@redotech/redo-model/draft-return/draft-return";
import { getCompensationMethod as getNullableCompensationMethod } from "@redotech/redo-model/draft-return/util";
export function getCompensationMethod(
  draftReturn: DraftReturn,
): CompensationMethod {
  const compensationMethod = getNullableCompensationMethod(draftReturn);
  if (!compensationMethod) {
    throw new Error("Compensation method not found");
  }
  return compensationMethod;
}
